import { Controller } from "@hotwired/stimulus"

// Visual selection state for the 4 content type cards on /admin/nouveau.
// On click, marks one card as selected and updates the hidden input.
export default class extends Controller {
  static targets = ["card", "input", "form"]
  static values = { selected: String }

  select(event) {
    event.preventDefault()
    const key = event.params.key
    if (!key) return
    this.selectedValue = key
    this.inputTarget.value = key
    this.cardTargets.forEach(card => {
      card.classList.toggle("is-selected", card.dataset.typeKey === key)
    })
  }
}
